import {
  BrowserAuthError,
  type IPublicClientApplication,
  type RedirectRequest,
} from '@azure/msal-browser';

let loginRedirectPromise: Promise<void> | null = null;

/**
 * Starts at most one login redirect at a time.
 *
 * Both route protection and API token acquisition can discover that user interaction
 * is required. Sharing the in-flight promise prevents concurrent callers from starting
 * competing redirects.
 */
export const startLoginRedirect = (
  instance: IPublicClientApplication,
  request: RedirectRequest
): Promise<void> => {
  loginRedirectPromise ??= Promise.resolve()
    .then(() => instance.loginRedirect(request))
    .catch(async (error: unknown) => {
      if (error instanceof BrowserAuthError && error.errorCode === 'interaction_in_progress') {
        // All application login entry points are coordinated here. If MSAL still reports
        // an interaction while no coordinated promise exists, the cache marker is stale.
        await instance.clearCache();
        await instance.loginRedirect(request);
        return;
      }

      throw error;
    })
    .finally(() => {
      loginRedirectPromise = null;
    });

  return loginRedirectPromise;
};
